export default "__VITE_ASSET__Bq2DrA2r__"